module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400-0bb428459c8ecfa61b22a03def1706e6.svg";